import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { NotiSettingModel, ServerNotiModel } from '../../view-models/server-notification';

@Injectable({
  providedIn: 'root'
})
export class ServerNotificationService {

  constructor(
    private apiService: ApiService,

  ) { }

  async getServerNotification(): Promise<ServerNotiModel> {
    const result = await this.apiService.getNotiSystemm<ServerNotiModel>('/noti-setting-elit/system');
    return result!
  }

  async aleartOnce(notiSysId:number): Promise<boolean> {
    const result = await this.apiService.patchNotiSystemm<boolean>(`/noti-setting-elit/system/log/${notiSysId}`);
    return result!
  }

  //NR
  async uploadFile(){
    
  }
  /*async uploadFile(file: File, notiSysId: number,server:number): Promise<PicServerNotiModel> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('notiSysId', String(notiSysId));
    formData.append('fileType', '1');
    let fileApiModel : any
   
      fileApiModel = await this.apiService.post<PicServerNotiModel>(`/noti-setting-eadmin/system/upload`, formData);
   
    let fileModel: PicServerNotiModel = null!;
    // if(fileApiModel){
    //   fileModel = this.mapper.mapFrom(fileApiModel);
    // }
    return fileApiModel!;
  }*/

}
